<template>
    <div class="modal-backdrop" v-if="renderComponent">
      <div class="modal">
        <button type="button"
                class="btn-close"
                @click="close"> x
        </button>
        <div class="content">
            <header class="modal-header">
                <slot name="header">
                    <h2>{{translate('surcharges_edit_header')}}</h2>

                </slot>
            </header>
            <div class="modal-body">
                <template v-if="surcharges.length>0">
                    <div class="column rows-container">
                        <div class="row header">
                            <span>{{translate('surcharges_title')}}</span>
                            <span>{{translate('surcharges_value')}}</span>
                            <span/>
                        </div>
                        <div class="row" v-for="(surcharge, key) in surcharges" :key="key">
                            <div class="title">
                              {{translateOption(surcharge.id, surcharge.title)}}
                            </div>
                            <div class="value" @click="surcharge.edit = true">
                                <div class="question-mark" v-if="translateHelp(surcharge.id, surcharge.title)" @mouseover="tooltip = surcharge.id" @mouseout="tooltip = -1">
                                    ?
                                    <div v-if="tooltip == surcharge.id" class="tooltip">{{ translateHelp(surcharge.id, surcharge.title) }}</div>
                                </div>
                                <span class="price" v-if="!surcharge.edit">{{$priceController.convertWithThousandSeparator(surcharge.value)}}</span>
                                <input type="text" @blur="surcharge.edit = false" v-else class="edit-input"
                                       v-model="surcharge.value" @change="validateEditedValue(surcharge)">
                                <span class="currency">EUR</span></div>
                            <div class="actions">
                                <span @click="removeSurcharge(key)">{{translate("surcharges_delete")}}</span>
                            </div>
                            

                          <ul v-if="surcharge.non_standard_surcharges == 1">
                            <li v-if="surcharge.options" v-for="(option, optKey) in surcharge.options" :key="optKey">
                              <div class="flex">
                                <p v-if="optionedit != optKey" @click="optionedit = optKey">
                                  {{option}}
                                </p>
                                <input type="text" @blur="optionedit = -1" v-else class="edit-input"
                                       v-model="surcharge.options[optKey]">
                                <span @click="removeSurchargeOption(key, optKey)">{{translate("surcharges_delete")}}</span>
                              </div>
                            </li>

                            <div class="add-custom-options-box">
                              <template v-if="surcharge.editMode && freshOptions.hasOwnProperty(key)">
                                <input type="text" class="edit-input" v-model="freshOptions[key]">
                                <div class="flex">
                                    <div @click="cancelAddingCustomOption(key)" class="add-custom-option-button cancel">
                                      <span>{{translate('cancel')}}</span>
                                    </div>
                                    <div @click="addSurchargeCustomOption(key)" class="add-custom-option-button">
                                      <span>{{translate('add')}}</span>
                                    </div>
                                  </div>
                              </template>
                              <template v-else>
                                <span class="add-custom-option"
                                  @click="addCustomOption(key)">+ {{translate('add_custom_option')}}</span>
                              </template>
                            </div>
                          </ul>
                        </div>
                    </div>
                </template>
                <div v-else>
                    <p>{{translate('surcharges_no_added_yet')}}</p>
                </div>
                <div class="add-surcharge-box">
                    <template v-if="fresh.editMode">
                        <div class="column">
                            <div class="row header">
                                <span>{{translate('surcharges_title')}}</span>
                                <span>{{translate('surcharges_value')}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="edit-box">

                                    <div class="custom-select">
                                        <div class="selected_item" :class="{'warn': errors.fresh_title}">
                                            <input class="value input-value"
                                                   :class="{'selected': isOptionSelected}"
                                                   v-model="searchOptionInputValue"
                                                   :placeholder="searchOptionInputIsFocused ? '' : (isOptionSelected ? translateOption(fresh.id, fresh.title) : translate('search_option'))"
                                                   @focus="focusOnSurchargesOptions"
                                                   @focusout="focusOutSurchargesOptions"
                                                   @input="inputSurchargesOptions"
                                            />
                                            <span class="icon-bottom_arrow"></span>
                                        </div>
                                        <div class="items-container" v-if="filteredOptions.length > 0">
                                            <div class="item" @click="selectTitle(option)" v-for="option in filteredOptions">
                                                <span>{{option.language[currentLocale].value}}</span>
                                            </div>
                                        </div>
                                      <div v-else class="items-container no-item">
                                        <div class="item">
                                          <span>{{ translate('no_results') }}</span>
                                        </div>
                                      </div>
                                    </div>
                            </div>
                            <div class="edit-box">
                                <input type="text" class="edit-input" v-model="fresh.value">
                                <span class="currency">EUR</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="box">
                                <div @click="cancelSurcharge" class="add-action-button cancel">
                                    <span>{{translate('cancel')}}</span>
                                </div>
                                <div @click="addSurcharge" class="add-action-button">
                                    <span>{{translate('surcharges_add_new')}}</span>
                                </div>
                            </div>

                        </div>
                    </template>
                    <template v-else>
                        <span class="add-process-btn"
                              @click="editNewAction">+ {{translate('surcharges_add_new')}}</span>
                    </template>
                </div>
                <p class="surcharges-total">{{translate('surcharges_total')}}: {{ $priceController.convertWithThousandSeparator(getTotalPrice.toFixed(2)) }} EUR</p>
            </div>
            <footer class="modal-footer">
                <slot name="footer">
                    <div class="navi-btns">
                        <span @click="close" class="back-btn circle-btn">
                        </span>
                        <button @click="save" class="summary-btn">{{translate("surcharges_approve")}}</button>
                    </div>
                </slot>
            </footer>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "modal",
        components: {},
        data() {
            return {
                tooltip: -1,
                optionedit: -1,
                lastDeleted: {},
                renderComponent: true,
                surcharges: [],
                errors: {
                    fresh_title: false
                },
                currentLocale: 0,
                options: [],
                fresh: {
                    title: '',
                    value: '',
                    id: '',
                    hidePrice: false,
                    non_standard_surcharges: 0,
                    editMode: false,
                    is_image_visible: false,
                    image: null,
                },
              freshOptions: {
              },
              searchOptionInputIsFocused: false,
              searchOptionInputValue: '',
              searchOptionFilterValue: '',
            }
        },
        methods: {
          inputSurchargesOptions() {
              this.searchOptionFilterValue = this.searchOptionInputValue;
          },

          focusOutSurchargesOptions() {
            this.searchOptionInputIsFocused = false;
            this.searchOptionInputValue = '';
          },

          focusOnSurchargesOptions() {
            this.searchOptionInputValue = '';
            this.searchOptionFilterValue = '';
            this.searchOptionInputIsFocused = true;
          },

          forceRerender() {
            this.renderComponent = false;

            this.$nextTick(() => {
              this.renderComponent = true;
            });
          },
            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            makePrice(string) {
                return parseFloat(string.replace(',', '.')).toFixed(2);
            },

            validateEditedValue(surcharge) {
                surcharge.value = this.makePrice(surcharge.value);
            },

            removeSurcharge(key) {
                this.lastDeleted = this.surcharges.splice(key, 1);
            },

            addCustomOption(key){
                this.freshOptions[key] = "";
                Vue.set(this.surcharges[key], "editMode", true);
            },

            cancelAddingCustomOption(key){
              Vue.set(this.surcharges[key], "editMode", false);

              if(this.freshOptions[key]){
                delete this.freshOptions[key];
              }
            },

            addSurchargeCustomOption(key){
              if(this.freshOptions[key]){
                if(!this.surcharges[key].hasOwnProperty("options") || !this.surcharges[key].options){
                  this.surcharges[key].options = [];
                }

                this.surcharges[key].options.push(this.freshOptions[key]);
              }

              this.cancelAddingCustomOption(key);
            },

            removeSurchargeOption(surchargeKey, optionKey){
              if(this.surcharges[surchargeKey].hasOwnProperty("options") && this.surcharges[surchargeKey].options.hasOwnProperty(optionKey))
                this.surcharges[surchargeKey].options.splice(optionKey, 1);

              Vue.set(this.surcharges[surchargeKey], "editMode", this.surcharges[surchargeKey].editMode);
              this.forceRerender();
            },

            editNewAction() {
                this.fresh.id = null;
                this.fresh.title = '';
                this.fresh.value = '';
                this.fresh.editMode = true;
                this.errors.fresh_title = false;
                this.fresh.image = null;
                this.fresh.is_image_visible = false;
            },

            validateFreshInput() {
                this.errors.fresh_title = false;

                if (this.fresh.title.length === 0) {
                    this.errors.fresh_title = true;
                    return false;
                }

                return true;
            },

            translateOption(id, code) {
              if(this.options){
                  let currentLang = this.getCurrentLocaleIndex(this.options);
                  let option = this.options.find(x => x.id.indexOf(id) !== -1);
                  if(option) {
                      let translation = option.language[currentLang].value;
                      if(translation) return translation;
                  }
              }
              return code;
            },

            translateHelp(id, code) {
              if(this.options){
                  let currentLang = this.getCurrentLocaleIndex(this.options);
                  let option = this.options.find(x => x.id.indexOf(id) !== -1);
                  if(option) {
                      let translation = option.language[currentLang].help;
                      if(translation) return translation;
                  }
              }
            },

            selectTitle(element) {
                this.fresh.title = element.code;
                this.fresh.id = element.id[0];
                this.fresh.non_standard_surcharges = element.non_standard_surcharges;
                this.fresh.image = element.image;
                this.fresh.is_image_visible = element.is_image_visible;
                if(element.default_price && element.default_price !== 0) {
                    this.fresh.value = this.makePrice(element.default_price);
                }
            },

            addSurcharge() {
                if (!this.validateFreshInput()) return;

                this.fresh.value = this.makePrice(this.fresh.value);
                // NVS-152 zostawiam tylko jedną powłokę przeciwkorozyjną
                if (this.fresh.title.includes('przeciwkorozyjna')) {
                    this.surcharges.forEach((el,index) => {
                        if (el.title.includes('przeciwkorozyjna')) delete this.surcharges.splice(index, 1);
                    })
                }
                this.surcharges.push(
                    {
                        title: this.fresh.title,
                        value: this.fresh.value,
                        id: this.fresh.id,
                        hidePrice: this.fresh.hidePrice,
                        non_standard_surcharges: this.fresh.non_standard_surcharges,
                        edit: false,
                        is_image_visible: this.fresh.is_image_visible,
                        image: this.fresh.image
                    }
                );
                this.fresh.editMode = false;
            },

            cancelSurcharge() {
                this.fresh.editMode = false;
            },

            calculateDiscount(price) {
                return parseFloat(this.$priceController.calculateDiscountRaw(price, this.$store.state.discount)).toFixed(2)
            },

            save() {
                let summary = this.$store.state.productCard.custom.summary.values;
                let keys = Object.keys(summary);
                for (let key of keys) {
                    if (key.includes('surcharge') && summary.hasOwnProperty(key) && typeof summary[key] === "object") delete summary[key];
                }

                for (let surcharge in this.surcharges) {
                    if (!this.surcharges.hasOwnProperty(surcharge)) break;
                    let object = this.surcharges[surcharge];
                    let option = this.options.find(x => x.id.indexOf(object.id) !== -1);

                    let mappedSurcharge = {
                        title: object.title,
                        value: this.calculateDiscount(object.value) + ' EUR',
                        id: object.id,
                        hidePrice: object.hidePrice,
                        non_standard_surcharges: object.non_standard_surcharges,
                        options: object.options,
                        price: object.value,
                        is_image_visible: option.language[0].is_image_visible,
                        image: option.language[0].image,
                    };

                    //NVS-152
                    const connectedClass = this.$store.state.offerAntiCorrosion.find(el => el.surcharge_code == mappedSurcharge.title)
                    if(connectedClass) {
                        this.$store.commit({
                            type: 'selectElementOfCorrosionProtectionValues',
                            valueId: connectedClass.id,
                            elementKey: 'class_category',
                            connectedKey: 'coating_thickness',
                            connectedValue: connectedClass.coating,
                            surcharge: connectedClass.surcharge_code
                        });
                    }

                    let keyName = 'surcharge_' + surcharge;
                    // NVS-217 - Vue.set powoduje znikanie akcesoriów w cenie - nikt nie wie dlaczego
                    //Vue.set(summary, keyName, mappedSurcharge);
                    summary[keyName] = mappedSurcharge;
                }
                this.close();
                this.$parent.$emit('updatePrice');
            },

            close() {
                this.$emit('close');
            },

            getCurrentLocaleIndex(options) {
                if(options.length>0){
                    return options[0].language.findIndex(x => x.id_language === this.$store.state.activeLang.id);
                }
            }
        },

        mounted() {
            this.options = this.$store.state.offerSurcharges;

            this.currentLocale = this.getCurrentLocaleIndex(this.options);

            let summary = this.$store.state.productCard.custom.summary.values;
            let keys = Object.keys(summary);
            let surcharges = [];

            for (let key of keys) {
                if (key.includes('surcharge') && summary.hasOwnProperty(key)) {
                    let obj = summary[key];
                    let options = obj && obj.hasOwnProperty("options") && Array.isArray(obj.options) ? [...obj.options] : null;
                    let surcharge = {
                        title: obj.title,
                        id: obj.id,
                        hidePrice: obj.hidePrice,
                        non_standard_surcharges: obj.non_standard_surcharges,
                        options: options,
                        value: obj.price,
                        edit: false,
                        image: obj.image,
                        is_image_visible: obj.is_image_visible,
                    }
                    surcharges.push(surcharge)
                }
            }

            this.surcharges = surcharges;
        },
        computed: {
            getTotalPrice() {
                return this.surcharges.reduce((acc, el) => {
                    if (el.value === null || isNaN(el.value)) el.value = 0;
                    acc += parseFloat(el.value);
                    if (isNaN(acc)) return 0;
                    return acc;
                }, 0);
            },
            filteredOptions() {
              return this.options.filter((option) => {
                return this.translateOption(option.id[0], option.code).toLowerCase().includes(this.searchOptionFilterValue.toLowerCase());
              })
          },

            isOptionSelected() {
              return (this.fresh.id || this.fresh.id === 0);
            }
        }
    }
</script>
